/* global ArticlesFilters */

document.querySelectorAll( '.b-articles' ).forEach( ( block ) => {

	new ArticlesFilters(  {
		'block': block,
		'buttonsID': '.filters__btn',
		'containerClass': '.b-articles__list',
		'ajaxAction': 'getAjaxArticles',
		'pagination': '.pagination a.page-numbers:not(.page-numbers--next):not(.page-numbers--prev)',
		'arrowPrevClass': '.page-number--next',
		'arrowNextClass': '.page-number--prev'
	} );

} );
